/**
 * @file Shared client input/upload size caps and clamp/assert helpers.
 */

export const INPUT_MAX_LENGTH = 200;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 200;
export const HIGH_VOLUME_MIN_ITEMS_MAX = 200;
export const ADMIN_NOTES_MAX_LENGTH = 2000;
export const BIDDER_NOTE_MAX_LENGTH = 2000;

/** Client-side upload caps (match backend multer defaults). */
export const MERGE_UPLOAD_MAX_BYTES = 10 * 1024 * 1024; // 10MB
export const CATEGORY_ASSIGNER_UPLOAD_MAX_BYTES = 10 * 1024 * 1024; // 10MB
export const INVENTORY_CSV_UPLOAD_MAX_BYTES = 5 * 1024 * 1024; // 5MB

export function clampInput(value, max = INPUT_MAX_LENGTH) {
  return String(value ?? '').slice(0, max);
}

export function assertFileSize(file, maxBytes, label = 'File') {
  if (!file) return `${label} is required`;
  if (file.size > maxBytes) {
    const mb = Math.round(maxBytes / (1024 * 1024));
    return `${label} must be ${mb}MB or smaller`;
  }
  return null;
}
